<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/wr1ttv/tc-custom/9781504070034.jpg?1705208140754" alt="This image is the cover for the book Grace, The Destiny Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Grace, The Destiny Series
      </h1>
      <p class="bookDescription body article font2">
        <b>Miles away from home, can you survive Christmas alone?</b><br/>  <br/> Singleton Grace loves Christmas and having all of her family with her on the day. But this year things will be different.<br/>  <br/> One by one, each of her three children announce they have other plans for the holidays.<br/>  <br/> After deciding it’s time for a change, Grace books a cottage in the French countryside for Christmas.<br/>  <br/> Max is also struggling with change after coming to terms with the end of his marriage. Making a spur of the moment decision, he heads to the Loire where he hopes to escape the festivities.<br/>  <br/> In the meantime, Grace’s children embark on their own Yuletide journeys. But when their plans begin to fall apart, they are all left wishing they were at home with their mum for Christmas.<br/>  <br/> Will Grace get what she originally wanted or is a festive surprise in store?<br/>  <br/><i>This book was previously published under the title </i>The Christmas Cottage<i>.</i><br/>  <br/> “Wonderful warm festive read.” —Amazon reviewer, five stars<br/>  <br/> “A lovely snuggly tale of love and family.” —Amazon reviewer, five stars<br/>  <br/> “The perfect book to curl up with.” —Amazon reviewer, five stars
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Patricia Dixon
      </h2>
      
      <p class="authorDescription body article">Patricia Dixon was born in Manchester where she still lives with her husband. They have two grown up children and one grandson, plus the company of a lazy bulldog.   Ignoring her high school reports and possibly sound advice from teachers, Patricia shunned the world of academia and instead, stubbornly pursued a career in fashion. Once the sparkle of London life wore off she returned north and embarked on a new adventure, that of motherhood.   Now, almost thirty years later she has acquiesced to the wise words of her elders and turned her hand to writing. Patricia has written five novels set in the Loire and then, in complete contrast, a much darker story of psychological suspense.  She is currently writing her next book, a murderous tale set in the sixties and if she’s not at her desk Patricia loves to read historical fiction or attempts recipes that look great on television but not necessarily her plate. And when the penny jar is full she cashes in her coins and heads to France, the lure of red wine and escapism equalled only by the pursuance of her dream job, writing for a living.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bombshell Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2fbdc913